export default __webpack_public_path__ + "static/media/Prometheus.b6e62ca2.png";